import {
  ILinkButtonSizeEnum,
  ILinkButtonVariantsEnum,
} from "@molecules/linkButton";
import { routePath } from "@routes/path";
import { IAuthStepEnum } from "@templates/authManagement/authStore";

import type { IFastLinkButtonVariantsData } from "@fastFields/fastLinkButton/types";

export const fastLinkButtonVariants: IFastLinkButtonVariantsData = {
  edit: {
    label: (t) => t("edit"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    endIcon: "ArrowLeftSLine",
  },
  loadMore: {
    label: (t) => t("loadMore"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
  },
  viewAll: {
    label: (t) => t("viewAll"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
  },
  forgetPassword: {
    label: (t) => t("page:auth.login.actions.forgetPassword"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Secondary,
    linkTo: routePath.authManagement.auth({
      type: IAuthStepEnum.RESET_PASSWORD?.toString(),
    }),
    hasUnderline: true,
  },
  return: {
    label: (t) => t("page:auth.header.actions.return"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    hasUnderline: true,
    linkTo: routePath.authManagement.auth({
      type: IAuthStepEnum.LOGIN?.toString(),
    }),
  },
  goToWebsite: {
    label: (t) => t("page:auth.header.actions.enterWebsite"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    hasUnderline: true,
    linkTo: "/",
  },
  resendCode: {
    label: (t) => t("page:auth.codeVerification.actions.resendCode"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Black,
    hasUnderline: true,
  },
  sendVerificationCode: {
    label: (t) => t("page:sendVerificationCode.sendCode"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    endIcon: "ArrowLeftSLine",
  },
  confirmEmail: {
    label: (t) => t("page:confirmEmail"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Primary,
    endIcon: "ArrowLeftSLine",
  },
  addNewProduct: {
    label: (t) => t("addNewOf", { name: t("entity:product") }),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Secondary,
    startIcon: "AddLine",
  },
  deleteAll: {
    label: (t) => t("deleteAll"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Error,
    startIcon: "EraserLine",
  },
  returnAllGoods: {
    label: (t) => t("returnAllGoods"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Error,
    startIcon: "TextWrap",
  },
  restoreAll: {
    label: (t) => t("restoreAll"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Black,
    startIcon: "RefreshLine",
  },
  addQuickProduct: {
    label: (t) => t("addQuickProduct"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Secondary,
    startIcon: "AddLine",
  },
  addQuick: {
    label: (t) => t("addQuick"),
    size: ILinkButtonSizeEnum.Medium,
    variant: ILinkButtonVariantsEnum.Secondary,
    startIcon: "AddLine",
  },
};
